const ElectricitySymbologyIcon = ({ ...props }) => {
    return (
        <svg
            width="24"
            height="12"
            viewBox="0 0 24 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            {...props}
        >
            <rect width="4" height="12" fill="#926807" />
            <rect x="4" width="4" height="12" fill="#4B87FF" />
            <rect x="8" width="4" height="12" fill="#FF4069" />
            <rect x="12" width="4" height="12" fill="#50B27E" />
            <rect x="16" width="4" height="12" fill="#9960C1" />
            <rect x="20" width="4" height="12" fill="#FF8FD1" />
        </svg>
    );
};

export default ElectricitySymbologyIcon;
